function resolveNativeBundler(args) {
  if (args.bundler === "metro" || process.env.ONE_METRO_MODE) return "metro";
  return "vite";
}
export {
  resolveNativeBundler
};
//# sourceMappingURL=nativeBundler.js.map
